import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../../../recoil/inset";
import { FranchiseHeader } from "./styles";

interface FranchiseHeaderProps {
  search: string;
  setSearch: (search: string) => void;
  onSearch: () => void;
}

const FranchiseHeaderComponent = ({
  search,
  setSearch,
  onSearch,
}: FranchiseHeaderProps) => {
  const history = useHistory();
  const inset = useRecoilValue(insetState);

  const handleBackClick = () => history.goBack();

  return (
    <FranchiseHeader isApp={inset}>
      <div className="close" onClick={handleBackClick}>
        <img
          src="/image-web/Icon/Back.svg"
          id="홀덤펍 찾기 뒤로가기"
          alt="close"
        />
      </div>
      <div className="input-wrapper">
        <input
          placeholder="내 주변 러너펍을 찾아보세요!"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              onSearch();
            }
          }}
        />
        <img
          src="image-web/search/search-icon.svg"
          alt="icon"
          onClick={() => onSearch()}
        />
      </div>
    </FranchiseHeader>
  );
};

export default FranchiseHeaderComponent;
